import type { V4HSiteId, SiteSectionCategoryId, SiteSectionId, ProgramId } from "@/data/common/ids";
import type { TBrand } from "@/utils/branded";

import { z } from "zod";

/**
 * Helper to build a Zod schema for branded IDs.
 * Type argument **must** be explicitly provided.
 */
function brandedIdSchema<BRAND extends TBrand<number, unknown>>() {
  return z.custom<BRAND>((data: any) => (typeof data === "number" || Number.isInteger(data)) && data > 0);
}

export const branded = {
  // Ids
  programId: brandedIdSchema<ProgramId>(),
  sectionCategoryId: brandedIdSchema<SiteSectionCategoryId>(),
  sectionId: brandedIdSchema<SiteSectionId>(),
  v4hSiteId: brandedIdSchema<V4HSiteId>(),
};
